module.exports = __webpack_public_path__ + "static/media/Test53.75a6ac97.bmp";